import CommentFooter from './CommentFooter';
import CommentFooterCoreBadges from './CommentFooter.core_badges';
import CommentFooterContainer from './CommentFooter.container';
import { withFeatureBranch } from '../../../redux/flags';
export default CommentFooterContainer(withFeatureBranch({
    core_badges: CommentFooterCoreBadges,
})(CommentFooter));
//# sourceMappingURL=index.js.map